import React from 'react'
import { groupBy, map, sortBy, sumBy, filter, round, get, isEmpty } from 'lodash'

import { DefaultCoverageDetails, AntiVirusCell, PatchingCell, AntiVirusDetails, PatchingDetails, SummaryCell, DataProtectionCell, DataProtectionDetails, MonitoringCell, MonitoringDetails } from 'FoundationalComponents/Reports/CoverageReportCells'
import ClientNameWithStatus from 'FoundationalComponents/ClientNameWithStatus'
import Icon from 'UI/FontAwesomeIcon'
import { CoverageCellAttributes } from 'FoundationalComponents/Reports/CoverageDefaults'
import { sortCoverageSummary } from 'FoundationalComponents/Reports/ColumnHelpers'
import VMSubMenu from 'FoundationalComponents/AssetSubMenus/VM'
import VcenterSubMenu from 'FoundationalComponents/AssetSubMenus/Vcenter'
import { Modal } from 'react-bootstrap'

const generateCoverageSummaryValue = (data, field, detailsFunction = DefaultCoverageDetails) => (
  sortBy(map(
    groupBy(data.vms, field),
    (vms, status) => ({ ...detailsFunction(status), count: vms.length })
  ), 'color')
)

const dataProtectionDetails = (original) => {
  const {
    last_backup: {
      commcell,
      storage_policy,
      status,
      error_message,
      start_at,
      end_at
    },
    last_backup
  } = original
  
  return (
    <Modal.Dialog style={{ margin: 0 }}>
      <Modal.Header>
        <Modal.Title>Backup details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isEmpty(last_backup) ? "This VM has no backup data" : (
          <div>
            <li>Commcell: {commcell}</li>
            <li>Storage policy: {storage_policy}</li>
            <li>Status: {status}</li>
            <li>Error message: {error_message}</li>
            <li>Backup start at: {start_at}</li>
            <li>Backup end at: {end_at}</li>
          </div>
        )}
      </Modal.Body>
    </Modal.Dialog>
  )
}

const vmColumns = () => [
  {
    Header: 'Location',
    id: 'location',
    type: 'list',
    sortMethod: (a, b) => {
      const location_a = find(a, ['label', 'Location'])
      const location_b = find(b, ['label', 'Location'])

      return (location_a.value > location_b.value ? 1 : -1)
    },
    accessor: (data) => ([
      { label: 'Location', value: data.location },
      { label: 'Cluster', value: data.cluster },
      { label: 'vCenter', value: <VcenterSubMenu vcenter={data.vcenter} /> }
    ])
  },
  { Header: 'VM', accessor: 'name', Cell: data => <VMSubMenu vm={data.original} /> },
  { Header: 'Power', accessor: 'power_state', type: 'powerState', width: 70 },
  { Header: 'Memory reservation cost', accessor: 'memory_reservation_cost', width: 70 },
  { Header: 'Machine Type', accessor: 'machine_type' },
  {
    Header: 'Data Protection',
    accessor: 'data_protection_coverage_status',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value, original }) => <DataProtectionCell {...{ value: value, details: dataProtectionDetails(original), vmID: original.id }} />,
  },
  {
    Header: 'Monitoring',
    accessor: 'monitoring_coverage_status',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value }) => <MonitoringCell {...{ value }} />,
  },
  {
    Header: 'Antivirus',
    accessor: 'antivirus_product',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value, original }) => <AntiVirusCell {...{ value: original.antivirus_coverage_status, antivirus_product: value }} />,
  },
  {
    Header: 'Patching',
    accessor: 'patching_coverage_status',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value }) => <PatchingCell {...{ value }} />,
  },
]

const customerColumns = () => [
  { Header: 'Customer', accessor: 'customer_name', filterable: true, Cell: data => (
    <ClientNameWithStatus data={data}>
      <a href={get(data, 'original.customer_href')} target='_blank' className='ms-2'>
        <Icon icon='external-link' />
      </a>
    </ClientNameWithStatus>
  )},
  { Header: 'VM Count', accessor: 'vms.length', type: 'number', width: 100 },
  {
    Header: 'Data Protection', id: 'data_protection_coverage_status', Cell: SummaryCell, type: 'number',
    sortMethod: sortCoverageSummary,
    accessor: (data) => generateCoverageSummaryValue(data, 'data_protection_coverage_status', DataProtectionDetails),
    style: { alignSelf: 'center' },
  },
  {
    Header: 'Monitoring', id: 'monitoring_coverage_status',
    style: { alignSelf: 'center', background: '#F2F2F2' }, Cell: SummaryCell, type: 'number',
    accessor: (data) => generateCoverageSummaryValue(data, 'monitoring_coverage_status', MonitoringDetails),
  },
  {
    Header: 'Antivirus', id: 'antivirus_coverage_status',
    style: { alignSelf: 'center', background: '#F2F2F2' }, Cell: SummaryCell, type: 'number',
    sortMethod: sortCoverageSummary,
    accessor: (data) => generateCoverageSummaryValue(data, 'antivirus_coverage_status', AntiVirusDetails),
  },
  {
    Header: 'Patching', id: 'patching_coverage_status',
    style: { alignSelf: 'center', background: '#F2F2F2' }, Cell: SummaryCell, type: 'number',
    sortMethod: sortCoverageSummary,
    accessor: (data) => generateCoverageSummaryValue(data, 'patching_coverage_status', PatchingDetails),
  },
]

export { vmColumns, customerColumns }
